import { render, staticRenderFns } from "./WorkClientAddressModal.vue?vue&type=template&id=062365ca&scoped=true&"
import script from "./WorkClientAddressModal.vue?vue&type=script&lang=js&"
export * from "./WorkClientAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientAddressModal.vue?vue&type=style&index=0&id=062365ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062365ca",
  null
  
)

export default component.exports